import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import AuthLayout from '../../components/auth/AuthLayout';
import { authService } from '../../services/api/authService';

const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    background: #1a1f24;
    color: #fff;
    border-radius: 8px;
    & fieldset {
      border-color: #42515E;
    }
    &:hover fieldset {
      border-color: #2563EB;
    }
    &.Mui-focused fieldset {
      border-color: #2563EB;
    }
  }
  & .MuiInputLabel-root {
    color: #b0b8c1;
  }
  & .MuiInputLabel-root.Mui-focused {
    color: #2563EB;
  }
`;

const StyledButton = styled(Button)`
  background: #2563EB;
  color: #fff;
  font-weight: 700;
  border-radius: 8px;
  padding: 12px 0;
  &:hover {
    background: #1d4ed8;
  }
`;

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await authService.forgotPassword(email);
            setSuccess(true);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to send reset link. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
      <AuthLayout>
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 700, mb: 1, fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' } }}>
          Forgot Password
        </Typography>
        <Box sx={{ mb: 3, color: '#b0b8c1', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          Enter your email address and we'll send you a link to reset your password
        </Box>
        {success ? (
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Alert severity="success" sx={{ mb: 2 }}>
              Password reset link has been sent to your email
            </Alert>
            <StyledButton
              variant="contained"
              onClick={() => navigate('/login')}
              sx={{ mt: 2, width: '100%' }}
            >
              Back to Login
            </StyledButton>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <StyledTextField
              margin="normal"
              required
              fullWidth
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
            <StyledButton
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </StyledButton>
            <StyledButton
              fullWidth
              variant="text"
              onClick={() => navigate('/login')}
              sx={{ mt: 1, color: '#2563EB', textTransform: 'none' }}
            >
              Back to Login
            </StyledButton>
          </Box>
        )}
      </AuthLayout>
    );
};

export default ForgotPasswordPage; 